module.exports = __webpack_public_path__ + "static/img/agroarca.6c6b767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/awards/agroarca.png
// module id = cyPc
// module chunks = 0